import type { InterventionHeaderActionsProps } from "./intervention-header-actions.type";

import ExportDatasetButton from "@/components/Export/ExportDatasetButton";
import ProgressButton from "@/components/Header/Button/ProgressButton";
import { useAuthorization } from "@/modules/authorization";
import { InterventionAssignButton } from "@/modules/intervention/intervention-assign";
import { InterventionDeleteButton } from "@/modules/intervention/intervention-delete-button";
import { InterventionDuplicateButton } from "@/modules/intervention/intervention-duplicate";
import { InterventionEditButton } from "@/modules/intervention/intervention-edit-button";
import { InterventionFollowupDropdown } from "@/modules/intervention/intervention-followup";
import { InterventionInfoButton } from "@/modules/intervention/intervention-info-button";
import ModelFavoriteButton from "@/modules/model-favorite-button";
import { StateEditForm } from "@/modules/state-edit-form";
import { ActionsBar } from "@/ui/actions-bar";

export const InterventionHeaderActions = ({
  intervention,
  loading,
}: InterventionHeaderActionsProps) => {
  const { canCreateModel, canUpdateItem, canAssignItem, canDeleteItem } =
    useAuthorization();

  if (!intervention || loading) return null;

  return (
    <ActionsBar
      primaryActions={[
        {
          key: "state",
          node: (
            <StateEditForm
              stateType="intervention"
              disabled={!intervention.intervention_template_id}
              model={intervention}
            />
          ),
        },
        {
          key: "progress",
          node: (
            <ProgressButton
              type="intervention"
              model={intervention}
              isEditable={canUpdateItem(intervention)}
            />
          ),
        },
        {
          key: "followup",
          node: <InterventionFollowupDropdown intervention={intervention} />,
        },
        {
          key: "info",
          node: <InterventionInfoButton intervention={intervention} />,
        },
        {
          key: "favorite",
          node: (
            <ModelFavoriteButton modelKey="intervention" item={intervention} />
          ),
        },
      ]}
      secondaryActions={[
        {
          key: "export",
          node: (
            <ExportDatasetButton
              templateId={intervention.intervention_template_id}
              params={{ "filter[intervention_id]": intervention.id }}
              buttonProps={{ type: "text" }}
            />
          ),
        },
        {
          key: "assign",
          hidden: !canAssignItem(intervention),
          node: (
            <InterventionAssignButton intervention={intervention} type="text" />
          ),
        },
        {
          key: "edit",
          hidden: !canUpdateItem(intervention),
          node: (
            <InterventionEditButton intervention={intervention} type="text" />
          ),
        },
        {
          key: "duplicate",
          hidden: !canCreateModel("intervention"),
          node: (
            <InterventionDuplicateButton
              intervention={intervention}
              type="text"
              showIcon
            />
          ),
        },
        {
          key: "delete",
          hidden: !canDeleteItem(intervention),
          node: (
            <InterventionDeleteButton intervention={intervention} type="text" />
          ),
        },
      ]}
    />
  );
};
